/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  List,
  MemberContentPermission,
  MemberRole,
  MemberRoleOrGuest,
  OrganizationMember,
  OrganizationTeam,
  TeamMember,
} from "./data-contracts";

/**
 * No description
 * @tags organization-members
 * @name ListMembersInOrganizationById
 * @summary List all organization members
 * @request GET:/orgs/{organizationId}/members
 * @secure
 */

// @ts-ignore
export const listMembersInOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
    /** The Role to filter the member list by */
    role?: MemberRole | "guest";
    /** A query to filter the member list (displayName and email) */
    search?: string;
    /**
     * The property to sort the results by. When sorting by lastSeenAt, only active members will be listed.
     * @default "joinedAt"
     */
    sort?: "joinedAt" | "lastSeenAt";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationMember[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members",
  method: "get",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members, critical
 * @name GetMemberInOrganizationById
 * @summary Get an organization member by its ID
 * @request GET:/orgs/{organizationId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const getMemberInOrganizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationMember;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}",
  method: "get",
  streaming: false,
  tags: ["organization-members", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name UpdateMemberInOrganizationById
 * @summary Update an organization member
 * @request PATCH:/orgs/{organizationId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const updateMemberInOrganizationById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationMember;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}",
  method: "patch",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name RemoveMemberFromOrganizationById
 * @summary Delete an organization member
 * @request DELETE:/orgs/{organizationId}/members/{userId}
 * @secure
 */

// @ts-ignore
export const removeMemberFromOrganizationById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/members/{userId}",
  method: "delete",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name UpdateOrganizationMemberLastSeenAt
 * @summary Update an organization member last seen at
 * @request POST:/orgs/{organizationId}/ping
 * @secure
 */

// @ts-ignore
export const updateOrganizationMemberLastSeenAt: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** A JTW token containing the claims to attach to this user. */
    gitbookVisitorClaims?: string;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/ping",
  method: "post",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name SetUserAsSsoMemberForOrganization
 * @summary Set a user as an SSO member of an organization
 * @request POST:/orgs/{organizationId}/members/{userId}/sso
 * @secure
 */

// @ts-ignore
export const setUserAsSSOMemberForOrganization: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationMember;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/sso",
  method: "post",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name ListSpacesForOrganizationMember
 * @summary List an organization member space permissions
 * @request GET:/orgs/{organizationId}/members/{userId}/spaces
 * @secure
 */

// @ts-ignore
export const listSpacesForOrganizationMember: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * An order for the items in the list
     * @default "desc"
     */
    order?: "asc" | "desc";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: MemberContentPermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/spaces",
  method: "get",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags organization-members
 * @name ListTeamsForOrganizationMember
 * @summary List all organization member teams
 * @request GET:/orgs/{organizationId}/members/{userId}/teams
 * @secure
 */

// @ts-ignore
export const listTeamsForOrganizationMember: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** If provided, only teams whose name contains the given parameter will be returned. Case insensitive. */
    title?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      team: OrganizationTeam;
      member: TeamMember;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/members/{userId}/teams",
  method: "get",
  streaming: false,
  tags: ["organization-members"],
  criticalityLevel: "low",
  deprecated: false,
};
